/**
 * 项目工期
 */
export const cardParam = [
    {
        content: '项目起始年限',
        backgroundColor: '#5ed0db',
        value: '0',
        editable: false,
    },
    {
        content: '项目建设期（年）',
        backgroundColor: '#b590f9',
        value: '0',
        editable: false,
    },
    {
        content: '项目运营期（年）',
        backgroundColor: '#8ac1f7',
        value: '0',
        editable: false,
    },
];

/**
 * 资金来源
 */
export const cardParam2 = [
    {
        content: '资本金比例(%)',
        backgroundColor: '#5ed0db',
        value: '0',
    },
    {
        content: '借款年利率(%)',
        backgroundColor: '#b590f9',
        value: '0',
    },
    {
        content: '计息次数',
        backgroundColor: '#8ac1f7',
        value: '0',
    },
    {
        content: '贷款年限',
        backgroundColor: '#f6c1a2',
        value: '0',
    },
    {
        content: '宽限期(年)',
        backgroundColor: '#97bffa',
        value: '0',
    },
    {
        content: '还款方式',
        backgroundColor: '#c3b8fa',
        value: '等额本息',
    },
];

/**
 * 资产形式
 */
export const cardParam3 = [
    {
        content: '固定资产比例(%)',
        backgroundColor: '#5ed0db',
        value: '0',
    },
    {
        content: '残值(%)',
        backgroundColor: '#b590f9',
        value: '0',
    },
    {
        content: '折旧年限',
        backgroundColor: '#8ac1f7',
        value: '0',
    },
    {
        content: '摊销年限',
        backgroundColor: '#f6c1a2',
        value: '0',
    },
];

/**
 * 生产成本
 */
export const cardParam4 = [
    {
        content: '定员(人)',
        backgroundColor: '#5ed0db',
        value: '0',
    },
    {
        content: '工资(万元/(人·年))',
        backgroundColor: '#b590f9',
        value: '0',
    },
    {
        content: '福利系数(%)',
        backgroundColor: '#8ac1f7',
        value: '0',
    },
    {
        content: '保险费率(%)',
        backgroundColor: '#f6c1a2',
        value: '0',
    },
    {
        content: '材料费(万元/年)',
        backgroundColor: '#97bffa',
        value: '0',
    },
    {
        content: '其他费用(万元/年)',
        backgroundColor: '#c3b8fa',
        value: '0',
    },
];

/**
 * 流动资金及财务费用
 */
export const cardParam5 = [
    {
        content: '流动资金贷款比例(%)',
        backgroundColor: '#5ed0db',
        value: '0',
    },
    {
        content: '短期贷款及流动资金利率(%)',
        backgroundColor: '#b590f9',
        value: '0',
    },
    {
        content: '应收账款年周转次数',
        backgroundColor: '#8ac1f7',
        value: '0',
    },
    {
        content: '存货年周转次数',
        backgroundColor: '#f6c1a2',
        value: '0',
    },
    {
        content: '现金年周转次数',
        backgroundColor: '#97bffa',
        value: '0',
    },
    {
        content: '应付账款年周转次数',
        backgroundColor: '#c3b8fa',
        value: '0',
    },
];

/**
 * 项目测算
 */
export const cardParam6 = [
    {
        content: '售电增值税税率%',
        backgroundColor: '#5ed0db',
        value: '0',
    },
    {
        content: '售汽增值税率%',
        backgroundColor: '#b590f9',
        value: '0',
    },
    {
        content: '售冷热增值税税率%',
        backgroundColor: '#8ac1f7',
        value: '0',
    },
    {
        content: '燃料增值税税率%',
        backgroundColor: '#f6c1a2',
        value: '0',
    },
    {
        content: '材料费进项增值税率%',
        backgroundColor: '#97bffa',
        value: '0',
    },
    {
        content: '法定公积金率%',
        backgroundColor: '#c3b8fa',
        value: '0',
    },
    {
        content: '任意公积金率%',
        backgroundColor: '#a2abfa',
        value: '0',
    },
    {
        content: '城市维护建设税税率%',
        backgroundColor: '#f7b3ae',
        value: '0',
    },
    {
        content: '教育费附加%',
        backgroundColor: '#a796f4',
        value: '0',
    },
    {
        content: '地方教育附加%',
        backgroundColor: '#f6c6c6',
        value: '0',
    },
    {
        content: '企业所得税税率%',
        backgroundColor: '#97b1fb',
        value: '0',
    },
    {
        content: '基准折现率%',
        backgroundColor: '#f7bd97',
        value: '0',
    },
];
